/* eslint no-restricted-globals: 0 */

import React from 'react';
import PropTypes from 'prop-types';

import Header from './header';

function Title({ item, className, maxLength, primary }) {
  let formattedTitle = item.sanitizedTitle || item.text;

  // decorate
  if (item.sectionItemIsTopic) {
    formattedTitle = `#${formattedTitle}`;
  }

  // truncate
  if (
    maxLength &&
    !isNaN(maxLength) &&
    formattedTitle &&
    formattedTitle.length >= maxLength
  ) {
    formattedTitle = `${formattedTitle.slice(0, maxLength)}…`;
  }

  return (
    <Header primary={primary} className={className}>
      {formattedTitle}
    </Header>
  );
}

Title.propTypes = {
  item: PropTypes.object.isRequired,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  primary: PropTypes.bool,
};

Title.defaultProps = {
  className: '',
  maxLength: null,
};

export default Title;
